<div class="info-dialog">
  <button class="close-btn" type="button" (click)="closeDialog()" [attr.aria-label]="'inclusion-index.info.close-aria' | translate">&times;</button>

  <div class="dialog-header">
    <h2>{{ 'inclusion-index.info.title' | translate }}</h2>
    <p>{{ 'inclusion-index.info.subtitle' | translate }}</p>
  </div>

  <section class="info-card score-card">
    <h3>{{ 'inclusion-index.info.total-score.title' | translate }}</h3>
    <div class="formula">
      <p class="formula-label">{{ 'inclusion-index.info.total-score.standard-label' | translate }}</p>
      <p class="formula-equation">{{ 'inclusion-index.info.total-score.standard-formula' | translate }}</p>
      <div class="weight-row" aria-hidden="true">
        <span class="weight-badge">40%</span>
        <span class="weight-badge">50%</span>
        <span class="weight-badge">10%</span>
      </div>
    </div>

    <div class="formula">
      <p class="formula-label">{{ 'inclusion-index.info.total-score.no-trainee-label' | translate }}</p>
      <p class="formula-equation">{{ 'inclusion-index.info.total-score.no-trainee-formula' | translate }}</p>
      <div class="weight-row" aria-hidden="true">
        <span class="weight-badge">90%</span>
        <span class="weight-badge">10%</span>
      </div>
    </div>
  </section>

  <section class="info-card">
    <h3>{{ 'inclusion-index.info.grades.title' | translate }}</h3>
    <div class="grade-grid" role="list">
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 4.6</span><span class="grade-value">A+</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">= 4.5</span><span class="grade-value">A</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 4.0</span><span class="grade-value">A-</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 3.6</span><span class="grade-value">B+</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">= 3.5</span><span class="grade-value">B</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 3.0</span><span class="grade-value">B-</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 2.6</span><span class="grade-value">C+</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">= 2.5</span><span class="grade-value">C</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 2.0</span><span class="grade-value">C-</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&gt;= 1.6</span><span class="grade-value">D+</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">= 1.5</span><span class="grade-value">D</span></div>
      <div class="grade-item" role="listitem"><span class="grade-range">&lt; 1.5</span><span class="grade-value">D-</span></div>
    </div>
  </section>

  <section class="info-card">
    <h3>{{ 'inclusion-index.info.level.title' | translate }}</h3>
    <div class="level-grid">
      <div class="level-item"><strong>A*</strong><span>{{ 'inclusion-index.info.level.advanced' | translate }}</span></div>
      <div class="level-item"><strong>B*</strong><span>{{ 'inclusion-index.info.level.intermediate' | translate }}</span></div>
      <div class="level-item"><strong>C*</strong><span>{{ 'inclusion-index.info.level.sufficient' | translate }}</span></div>
      <div class="level-item"><strong>D*</strong><span>{{ 'inclusion-index.info.level.insufficient' | translate }}</span></div>
    </div>
  </section>
</div>
